import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useApp } from '@/hooks/use-app-context';
import { isPlaceQuery } from './collection-place.contract';
import { collectionPlaceQueryOptions } from './collection-place.service';
import { collectionPlaceService } from './collection-place.service';

/** Waits for the typing to settle: one request per pause, not per key. */
const DEBOUNCE_MS = 350;

export function usePlaceSearch(query: string) {
  const { language, user } = useApp();
  const lang = language === 'en' ? 'en' : 'fr';
  const homePlace = useQuery({
    ...collectionPlaceQueryOptions(user?.id ?? 'anonymous', lang),
    enabled: false,
  });
  const countryCode = user ? homePlace.data?.countryCode : undefined;
  const [settled, setSettled] = useState(query.trim());

  useEffect(() => {
    const timer = window.setTimeout(() => setSettled(query.trim()), DEBOUNCE_MS);
    return () => window.clearTimeout(timer);
  }, [query]);

  const search = useQuery({
    queryKey: ['geo', 'places', lang, countryCode ?? 'all', settled.toLocaleLowerCase()],
    queryFn: () => collectionPlaceService.searchPlaces(settled, lang, countryCode),
    enabled: isPlaceQuery(settled),
    staleTime: 10 * 60_000,
    retry: false,
  });
  return { ...search, isSettled: settled === query.trim() };
}
